import { useAppState } from "../../context/appStateContext"
import { PaywallItem, usePurchase } from "../../context/purchaseContext"
import images from "../../utils/images"
import PrimaryButton from "../PrimaryButton/PrimaryButton"
import Switch from "react-ios-switch"
import styles from "./PaywallListFooter.module.scss"
import useStrings from "../../localization/useStrings"

const PaywallListFooter = () => {
  const bottomInset = useAppState().state.initialData?.bottomInset ?? 0
  const { state, actions } = usePurchase()

  return (
    <div className={styles.container}>
      <div className={styles.background} style={{ bottom: -bottomInset }}></div>
      {state.toggleableFreeTrial && <ToggleTrial />}
      <div className={styles.selection}>
        <PaywallListItem
          item={state.yearlyItem}
          onClick={() => actions.setYearlySelected(true)}
        />
        <PaywallListItem
          item={state.monthlyItem}
          onClick={() => actions.setYearlySelected(false)}
        />
      </div>
      <div className={styles.ctaContainer}>
        <PrimaryButton onClick={() => actions.purchaseCurrent()}>
          {state.ctaTitle}
        </PrimaryButton>
      </div>
    </div>
  )
}

interface PaywallListItemProps {
  item: PaywallItem
  onClick: () => void
}

const PaywallListItem = (props: PaywallListItemProps) => {
  const { toggleableFreeTrial, freeTrialToggled } = usePurchase().state
  const strings = useStrings()

  const item = props.item
  const selected = item.selected

  const paywallImages = images.premium.default

  const checkBoxImage = selected
    ? paywallImages.checkBox
    : paywallImages.checkBoxUnchecked
  const selectionStyle = selected ? styles.selected : ""

  let discountTitle = item.discount

  if (toggleableFreeTrial && discountTitle != null) {
    discountTitle = freeTrialToggled
      ? strings.trialActivated(7)
      : strings.popular
  }

  return (
    <button
      className={`${styles.pricing} ${selectionStyle}`}
      onClick={props.onClick}
    >
      {item.discount && <div className={styles.discount}>{discountTitle}</div>}
      <div className={styles.leftPricing}>
        <span className={styles.time}>{item.title}</span>
        {item.yearlyPrice && (
          <span className={styles.perYear}>{item.yearlyPrice}</span>
        )}
      </div>
      <div className={styles.rightPricing}>
        <span className={styles.price}>{item.monthlyPrice}</span>
        <div className={`${checkBoxImage.class} ${styles.checkbox}`} />
      </div>
    </button>
  )
}

const ToggleTrial = () => {
  const { state, actions } = usePurchase()

  const root = document.documentElement
  const primaryColor = getComputedStyle(root)
    .getPropertyValue("--color-primary")
    .trim()
  const offColor = getComputedStyle(root)
    .getPropertyValue("--pricing-selected-stroke")
    .trim()
  const strings = useStrings()

  return (
    <div className={styles.toggleContainer}>
      <label className={styles.toggleTitle}>{strings.enableTrial}</label>
      <Switch
        checked={state.freeTrialToggled}
        onChange={actions.setFreeTrialToggled}
        offColor={offColor}
        onColor={primaryColor}
      />
    </div>
  )
}

export default PaywallListFooter
